import { initialAccountContactFormData } from 'components/accountContact/constants'
import { AccountRepFormData } from './types'

export const initialAccountRepFormData: AccountRepFormData = {
  ...initialAccountContactFormData,
  emailAddress: '',
}

export const AccountRepStandardOptions = {
  MYSELF: 'myself',
  SOMEONE_ELSE: 'someoneElse',
}

export const AllAccountRepStandardOptions = Object.values(AccountRepStandardOptions)
